<script>
    import { onMount } from "svelte";
    import axios from "axios";

    export let params;

    onMount(async () => {
        await axios
            .post(APIBACKEND + "/user", params, { withCredentials: true })
            .then(function (res) {
                window.location.replace("/account");
            })
            .catch((error) => {
                window.location.replace("/");
            });
    });
</script>
